import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-04-18 11:17:33
 * @LastEditTime: 2022-04-18 11:48:33
 * @FilePath: \insurforce-backstage-platform-side\src\views\claim\customerRecordManage\request.js
 */
import request from '@/utils/request2';

// 理赔记录
export function claimsList(data) {
  return request.post('admin/claims/list', data);
}
// 理赔记录详情
export function claimsHomeDetail(data) {
  return request.post('admin/claims/detail', data).then(res => {
    console.log(res.claimsInfo);
    res.claimsInfo.claimsDocument.map(i2 => {
      i2.documentUrl.map((i, index) => {
        i.status = 'done';
        i.uid = index + 1;
        return i;
      });
      return i2;
    });
    return res;
  });
}
// 下载证件资料
export function claimsZip(data) {
  return request.post('admin/claims/zip', data);
}
//理赔文件清单(物理邮寄)
export function documentList(data) {
  return request.post('admin/claims/document', data).then(res => {
    res.map(item => {
      item.isChecked = false;
      item.remark = '';
      return item;
    });
    return res;
  });
}
//理赔材料邮寄配置
export function mailingConfig(data) {
  return request.post('admin/claims-mailing/config', data);
}
// 填写邮寄信息
export function mailingInfo(data) {
  return request.post('admin/claims-mailing-logistics/store', data);
}
// 修改邮寄信息
export function editMailing(data) {
  return request.post('admin/claims-mailing-logistics/edit', data);
}
//查看邮寄信息
export function mailingDetail(data) {
  return request.post('admin/claims-mailing/detail', data).then(res => {
    if (res) {
      res.list.map(item => {
        item.isChecked = false;
        item.remark = item.remark || '';
        return item;
      });
    }
    return res;
  });
}
// 查看邮寄信息(只有快递公司和运单号)
export function mailingLook(data) {
  return request.post('admin/claims-mailing/look', data);
}
//理赔材料邮寄配置
export function editClaims(data) {
  return request.post('admin/claims/edit', data);
}
//收件地址资源
export function consigneeResource(data) {
  return request.post('admin/consignee/resource', data);
}
//收件地址新增
export function addConsignee(data) {
  return request.post('admin/consignee/store', data);
}
//收件地址--设置默认
export function consigneeDefault(data) {
  return request.post('admin/consignee/default', data);
}
//收件地址删除
export function delConsignee(data) {
  return request.post('admin/consignee/delete', data);
}
//收件地址删除
export function claimsClosed(data) {
  return request.post('admin/claims/closed', data);
}
//理赔进度
export function claimsSchedule(data) {
  return request.post('admin/claims/schedule', data);
}
//根据保险id获取配置的字段数据
export function claimsField(data) {
  return request.post('admin/claims/insurance-list', data);
}
//根据保险id获取配置的字段数据
export function recordExport(data) {
  return request.post('admin/claims/record-export', data);
}
export function getTags(data) {
  return request.post('admin/claims/getTags', data);
}